import React from "react"
import PropTypes from "prop-types"
import DropdownSelect from '../../form_sections/DropdownSelect'
import { semantic, foundations } from '@lexody/design-tokens'

class NationalitySection extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      allNationalities: [],
      loaded: false
    }

    this.showNationalities = this.showNationalities.bind(this)
  }

  componentDidMount() {
    $.ajax({
      url: '/get_all_nationalities',
      dataType: 'json',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          allNationalities: JSON.parse(data.data.nationalities),
          loaded: true
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  showNationalities() {
    return this.state.allNationalities.map((nationality, i)  => {
      const selected = nationality.id === this.props.user.nationality_id
      return(
        <div
          onClick={() => this.props.updateUser(nationality.id, 'nationality_id')}
          key={i}
          className="clickable"
          style={{
            border: `${foundations.border.width.focus}px solid ${semantic.primary.border.default}`,
            padding: 10,
            borderRadius: foundations.radius.full,
            margin: 5,
            backgroundColor: !selected ? 'white' : semantic.primary.surface.default
          }}>
            <h5 className="bold" style={{color: selected ? semantic.greyscale.text.negative : semantic.primary.surface.default}}>{nationality.name}</h5>
        </div>
      )
    })
  }

  render() {
    return(
      <DropdownSelect
        label={'Nationality'}
        attribute={'nationality'}
        value={this.props.user.nationality}
        onChange={this.props.updateUser}
        placeholder={'Nationality'}
        items={this.state.allNationalities}
        itemAttribute={'nationality'}
        itemSelector={'nationality'}
        icon="globe"
        tone="purple"
        variant={this.props.variant}
      />
    )
  }
}

export default NationalitySection;
